<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cMxz62/tc-custom/9781035844852.jpg?1705541262404" alt="This image is the cover for the book Abbie Brown: On the Cusp"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Abbie Brown: On the Cusp
      </h1>
      <p class="bookDescription body article font2">
        <p>Abbie Brown kicks off her 34th year with an unexpected splash of fame: her Santorini vacation snap, featuring her in a vibrant yellow bikini atop a donkey, is plastered on billboards across London. (For clarity, the bikini is on Abbie, not the donkey!) Riding this wave of newfound celebrity, she lands a spot on Sir Giles Bromley’s BBC gardening show. Life seems perfect, until the universe serves her a slice of humble pie. Navigating the chaos of single life (weighing in at 73kgs, if you must know), Abbie finds herself in the midst of an office medical drama, dealing with her nightmare flatmate Janice, and questioning if Rebecca truly is the refined acquaintance she seems. As for romance? Between George’s overbearing mother, Oliver’s youth, a married butcher, a BBC exec with a cringe-worthy habit, and the not-so-perfect ‘Peter Perfect,’ Abbie’s love life is a rollercoaster. Yet, she remains hopeful that her knight in shining armor is out there in the vast English countryside. In the midst of it all, she gains a furry companion: Woofer, a lovable terrier with a quirky ear. Plus, there’s a promising spark with a dashing farmer from the Yorkshire Dales. The two are smitten. (We’re talking about Abbie and the farmer, not the dog, of course!) But with Abbie’s track record, what could possibly go awry? Dive into a tale of unexpected fame, comedic misadventures, and the quest for true love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carmel Liddell
      </h2>
      
      <p class="authorDescription body article">Carmel Liddell’s latest novel, Abbie Brown: On the Cusp, explores the life and times of 34-year-old Abbie (single – 73kgs), who is looking for love. Having been there, and done that, Carmel tells the tale with a great deal of humour, affection and understanding. The Australian author’s other books include Short Stories A-Z – 2023 Love and Kisses Pauline xxx – 2022 Reggie Carstairs: Behind Closed Eyes – 2021 The Beachmaster (Childrens’ Picture Book) - 2026</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?48ba4b2b